import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { initializeApp } from "firebase/app";
import { getAnalytics, setAnalyticsCollectionEnabled } from "firebase/analytics";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import './App.css';
import './Tabs.css'; // Add styles here
import Footer from './components/Footer';
import Properties from './Properties';
import MyAccount from './MyAccount';
import AboutUs from './AboutUs';
import Terms from './Terms';
import Privacy from './Privacy';
import ContactUs from './ContactUs';
import FAQs from './FAQs';
import ResetPassword from './ResetPassword';
import CreateAccount from './CreateAccount';
import Login from './Login';
import Demo from './Demo';
import CustomResetPassword from './CustomResetPassword';
import { Helmet } from 'react-helmet';

// Firebase configuration
const firebaseAPIKey = process.env.REACT_APP_FIREBASE_API_KEY;

const firebaseConfig = {
  apiKey: firebaseAPIKey,
  authDomain: "property-ranker.firebaseapp.com",
  projectId: "property-ranker",
  storageBucket: "property-ranker.firebasestorage.app",
  messagingSenderId: "392160926638",
  appId: "1:392160926638:web:32df7465675b7cb785063f",
  measurementId: "G-W9CBC2L5F4"
};

function ProtectedRoute({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, [auth]);

  if (loading) {
    return <p>Loading...</p>; // Prevents flickering of content
  }

  return user ? children : <Navigate to="/login" replace />;
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);  

function App() {

  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [showCookieBanner, setShowCookieBanner] = useState(false);
  const [user] = useState(null);


  useEffect(() => {
    const fetchKillSwitch = async () => {
      const db = getFirestore();
      const docRef = doc(db, "configurations", "maintenanceMode"); // Reference the document
      const docSnap = await getDoc(docRef); // Fetch the document
      if (docSnap.exists()) {
        const data = docSnap.data(); // Get the document's data
        setMaintenanceMode(data.killSwitch); // Access the 'killSwitch' field
      } else {
        console.error("Maintenance configuration not found");
      }
    };

    fetchKillSwitch(); // Call the fetch function
  }, []); 


  useEffect(() => {
    
    const userConsent = localStorage.getItem("cookieConsent");
    console.log(userConsent);

    if (userConsent === "accepted") {
      setAnalyticsCollectionEnabled(analytics, true);
      setShowCookieBanner(false);
    } else if (userConsent === "rejected") {
      setAnalyticsCollectionEnabled(analytics, false);
      setShowCookieBanner(false);

    } else {
      setShowCookieBanner(true);
    }
  }, []);

  const handleAcceptCookies = () => {
    setAnalyticsCollectionEnabled(analytics, true);
    localStorage.setItem("cookieConsent", "accepted");
    setShowCookieBanner(false);
  };

  const handleRejectCookies = () => {
    setAnalyticsCollectionEnabled(analytics, false);
    localStorage.setItem("cookieConsent", "rejected");
    setShowCookieBanner(false);
  };


  if (user) {
    return <Navigate to="/properties" replace />;
  }

  if (maintenanceMode) {
    return (
      <div className="App">
        <header className="App-header">
          <h1><img src='/imgs/domorango.png' alt="Domogogo" className="header-logo header-home" /></h1>
          <div className='maintenance-window'>
            <h2>Thanks for your interest in Domogogo!</h2><br/>
            <p>We’re currently undergoing maintenance. For more information, please email <a href="mailto:help@domogogo.com">help@domogogo.com</a>.</p>
          </div>
        </header>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Domogogo - Your Ultimate Property Search Tool</title>
        <meta name="description" content="Take the emotion out of property searching and put some numbers behind it! Rank and analyze properties with ease." />
        <meta property="og:title" content="Domogogo" />
        <meta property="og:description" content="Your ultimate tool to help you in your property search. Take the emotion out of it and put some numbers behind it!" />
        <meta property="og:image" content="http://www.domogogo.com/imgs/social.jpeg" />
        <meta property="og:url" content="https://www.domogogo.com" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

    <div className="App">
    {showCookieBanner && (
  <div className="cookie-banner" style={{position: 'fixed',bottom: 0, width: '100%',backgroundColor: '#f8f9fa',padding: '10px 0', boxShadow: '0 -2px 5px rgba(0,0,0,0.25)', zIndex: 1000,}}>
    <div
      className="cookie-banner-holder" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '80%',margin: '0 auto',}}>
      <p style={{ fontSize: '14px', margin: 0 }}>
        <strong style={{ fontSize: '15px' }}>Help us improve the experience</strong>
        <br />
        We use cookies to ensure the proper functioning of our website and to analyze its usage. By clicking "Accept All" you agree to the use of analytics cookies. You can reject analytics cookies by clicking "Only Essential".
      </p>
      <div
        style={{
          display: 'flex',
          gap: '10px',
        }}
        className="cookie-buttons"
      >
        <button
          className="cookie-accept"
          onClick={handleAcceptCookies}
          style={{color: '#fff',backgroundColor: '#007bff',border: 'none',padding: '8px 16px',borderRadius: '4px',cursor: 'pointer',}}
        >
          Accept All
        </button>
        <button
          className="cookie-reject"
          onClick={handleRejectCookies}
          style={{
            color: '#007bff',
            backgroundColor: '#fff',
            border: '1px solid #007bff',
            padding: '8px 16px',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        >
          Only Essential
        </button>
      </div>
    </div>
    <style>
      {`
        @media (max-width: 768px) {
          .cookie-banner > div {
            flex-direction: column;
            text-align: center;
          }
        }
      `}
    </style>
  </div>
)}
      <header className="App-header">
       <div className="header-holder">
        <h1><img src='/imgs/domorango.png'  alt="TBC" className="header-logo header-home" style={{maxWidth:"300px"}}/></h1>
        <div className="signup-link">
          <a className="signup-link-button" href="/create-account">CREATE ACCOUNT</a>
          <a className="login-link" href='/login'>LOGIN</a>
        </div>
      </div>

        <div className="content-landing">
          <div className="content-text">
              <h1 style={{ margin: "0 0 20px" }}>Your ultimate tool to help you in your property search.</h1>
              <p style={{color: "#fff"}}>
                Take the emotion out of it and put some numbers behind it!
              </p>
              <div className="web-signup-links">
                <a className="signup-link-button" href="/create-account" style={{padding:"8px 16px",fontSize:"16px"}}>SIGN UP FOR FREE</a>
                <a className="login-link" href="/login" style={{padding:"8px 16px",fontSize:"16px"}}>LOGIN</a>
              </div>
          </div>
            <div className="content-image">
              <img src="./imgs/new-slider1-sm.png" alt="Illustration" style={{ maxWidth: "100%", height: "auto", borderRadius: "8px", width: "auto", objectFit: "contain" }}/>
            </div>
            <div className="mobile-signup-links">
              <a className="signup-link-button" href="/create-account" style={{padding:"8px 16px",fontSize:"16px"}}>SIGN UP FOR FREE</a>
              <a className="login-link" href="/login" style={{padding:"8px 16px",fontSize:"16px"}}>LOGIN</a>
            </div>
       
        </div>
      </header>
      <div style={{background:'#f5f5f5',width:'100%'}}>
      <div className="feature-showcase-holder">
        {/* Feature 1 */}
        <div className="feature-box">
          <h2>Pick your priorities...</h2>
          <img src="./imgs/new-slider1a.png" alt="Feature One" />
        </div>
        
        {/* Feature 2 */}
        <div className="feature-box">
          <h2>...add in your properties...</h2>
          <img src="./imgs/new-slider2a.png" alt="Feature Two" />
        </div>
        
        {/* Feature 3 */}
        <div className="feature-box">
          <h2>...score as you tour</h2>
          <img src="./imgs/new-slider3a.png" alt="Feature Three" />
        </div>
      </div>
      </div>


        <div className="bottom-box">
          <h2>And leave the rest to us!</h2>
          <p>
            Our algorithms will take your characteristics, priorities, scores, and prices and give you our ranking to help you decide which is the perfect home for you.
          </p>
          <img 
            src={window.innerWidth < 768 ? "./imgs/new-slider-top2.png" : "./imgs/new-slider4a.png"} 
            alt="Feature One"
          />
        </div>
        <div style={{width:"100%", margin:"auto", fontSize:"16px", textAlign:"center", padding:"20px 10px 30px 10px"}}>
        <a className="signup-link-button-cta" href="/demo" style={{padding:"8px 16px",fontSize:"14px", marginTop:"20px"}}>TRY OUT OUR DEMO TOOL TODAY</a><br/><br/>
        <a style={{color:'black'}}href='/login'>Already got an account? Login</a>
        </div>

    <Footer />
    </div>
    </>
  );
}

export default function AppRouter() {

  const [maintenanceMode, setMaintenanceMode] = useState(false);

  useEffect(() => {
    const fetchKillSwitch = async () => {
      const db = getFirestore();
      const docRef = doc(db, "configurations", "maintenanceMode"); // Reference the document
      const docSnap = await getDoc(docRef); // Fetch the document
      if (docSnap.exists()) {
        const data = docSnap.data(); // Get the document's data
        setMaintenanceMode(data.killSwitch); // Access the 'killSwitch' field
      } else {
        console.error("Maintenance configuration not found");
      }
    };

    fetchKillSwitch(); // Call the fetch function
  }, []);
  
  return (
    <Router>
      <Routes>
        {maintenanceMode ? (
          <Route
            path="*"
            element={
              <div className="App">
                <header className="App-header">
                  <h1>
                    <img src="/imgs/domorango.png" alt="Domogogo" className="header-logo" />
                  </h1>
                  <div className="maintenance-window">
                    <h2>Thanks for your interest in Domogogo!</h2>
                    <br />
                    <p>
                      We’re currently undergoing maintenance. For more information, please email{' '}
                      <a href="mailto:help@domogogo.com">help@domogogo.com</a>.
                    </p>
                  </div>
                </header>
              </div>
            }
          />
        ) : (
          <>
            <Route path="/" element={<App />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/reset-your-password" element={<CustomResetPassword />} />

            <Route 
              path="/properties" 
              element={
                <ProtectedRoute>
                  <Properties analytics={analytics} />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/my-account" 
              element={
                <ProtectedRoute>
                  <MyAccount />
                </ProtectedRoute>
              } 
            />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/create-account" element={<CreateAccount analytics={analytics} />} />
            <Route path="/login" element={<Login />} />
            <Route path="/demo" element={<Demo />} />
          </>
        )}
      </Routes>
    </Router>
  );
}
